import styled from 'astroturf/react'
const fontSizeTitleLarge = 'var(--fontSizeTitleLarge, 1.375rem)'
import { Loader } from '@calendly/ui/components/loader'

import { useI18n } from 'locales'
import CircleCheck from 'components/confirmation/circle-check.svg'
import { GmailConfirmation } from 'components/confirmation/gmail_confirmation'
import PaymentMessage from 'components/confirmation/pages/new_confirmation/payment_message'
import ErrorAlert from 'components/error/alert'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import _Header from "Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=Header";
import _TitleLine from "header-TitleLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=TitleLine";
import _Icon from "header-Icon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=Icon";


const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

const TitleLine = /*#__PURE__*/styled('h2', null, {
  displayName: "TitleLine",
  styles: _TitleLine
})

const Icon = /*#__PURE__*/styled('img', null, {
  displayName: "Icon",
  styles: _Icon
})

export const PersonalizedHeader = () => {
  const { event } = useConfirmationPageData()
  const { isReschedulingFlow, fullName, shouldSeeGmailSniperLink } = useConfirmationPageData()
  const { i18n } = useI18n()

  const titleText = isReschedulingFlow
    ? i18n.t('booking.templates.rescheduled')
    : i18n.t('booking.templates.scheduled')

  if (event === undefined) return <Loader />
  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  return (
    <Header data-component="confirmation-header">
      <Icon src={CircleCheck} alt="" />
      <TitleLine>
        {titleText}
        {fullName && `, ${fullName}!`}
      </TitleLine>
      <PaymentMessage />
      {shouldSeeGmailSniperLink && <GmailConfirmation />}
    </Header>
  )
}
